import { combineReducers } from "redux";

import marketplace from "./marketplace.js";
import profile from "./profile.js";
import wallet from "./wallet.js";
import icxPricing from "./icxPricing.js";
import home from "./home.js";
import leaderboard from "./leaderboard.js";
import activityLog from "./activityLog.reducer.js";

const rootReducer = combineReducers({
  marketplace,
  profile,
  wallet,
  icxPricing,
  home,
  activityLog,
  leaderboard,
  activityLog,
});

export default rootReducer;
